/** 8 x 8 tool icons, drawn pixel by pixel in the font's style (`#` ink, `.` clear). */

import type { Screen } from '../../render/screen';
import type { ToolId } from '../model/shapes';

const ICONS: Readonly<Record<ToolId, string>> = {
  pencil: '......##|.....#.#|....#.#.|...#.#..|..#.#...|.###....|.##.....|#.......',
  line: '##......|##......|..#.....|...#....|....#...|.....#..|......##|......##',
  rect: '########|#......#|#......#|#......#|#......#|#......#|#......#|########',
  box: '########|########|########|########|########|########|########|########',
  flood: '...#....|..#.#...|.#...#..|#..#..#.|.#.###.#|..#.#..#|...#...#|.......#',
  picker: '.....###|....####|...####.|..#.#...|.#.#....|#.#.....|##......|#.......',
};

export function drawIcon(s: Screen, tool: ToolId, x: number, y: number, colour: number): void {
  ICONS[tool].split('|').forEach((row, dy) => {
    for (let dx = 0; dx < row.length; dx++) if (row[dx] === '#') s.fill(x + dx, y + dy, 1, 1, colour);
  });
}
